export default {
	events: {
		'ddc.link.generic': [
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('explore-incentives'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:lp:fuel efficient:technologies:explore incentives',
							onclickLinkName: 'referral:exit',
							referredTo:
								'fv:lp:fuel efficient:technologies:explore incentives'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('find-your-mustang-mach-e'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:lp:fuel efficient:technologies:find your mustang mach e',
							onclickLinkName: 'referral:exit',
							referredTo:
								'fv:lp:fuel efficient:technologies:find your mustang mach e'
						},
						vehicle: {
							modelYear: '2025',
							nameplate: 'Ford Mach-E'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('find-your-f150-lightning'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:lp:fuel efficient:technologies:find your f150 lightning',
							onclickLinkName: 'referral:exit',
							referredTo:
								'fv:lp:fuel efficient:technologies:find your f150 lightning'
						},
						vehicle: {
							modelYear: '2025',
							nameplate: 'Ford f-150 Lightning'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('learn-about-installation'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:lp:fuel efficient:technologies:installation',
							onclickLinkName: 'referral:exit',
							referredTo:
								'fv:lp:fuel efficient:technologies:installation'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('home-charging'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:lp:fuel efficient:technologies:home charging',
							onclickLinkName: 'referral:exit',
							referredTo:
								'fv:lp:fuel efficient:technologies:home charging'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('public-charging'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:lp:fuel efficient:technologies:public charging',
							onclickLinkName: 'referral:exit',
							referredTo:
								'fv:lp:fuel efficient:technologies:public charging'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('charging-tools'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:lp:fuel efficient:technologies:charging tools:charging near me',
							onclickLinkName: 'referral:exit',
							referredTo:
								'fv:lp:fuel efficient:technologies:charging tools:charging near me'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('intelligent-range'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:lp:fuel efficient:technologies:charging tools:intelligent range',
							onclickLinkName: 'referral:exit',
							referredTo:
								'fv:lp:fuel efficient:technologies:charging tools:intelligent range'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('make-the-switch'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick:
								'referral:fv:lp:fuel efficient:technologies:make the switch ',
							onclickLinkName: 'referral:exit',
							referredTo:
								'fv:lp:fuel efficient:technologies:make the switch'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			}
		]
	}
};
